/* tslint:disable */
import * as THREE from "three";

export class Sharing3DViewData {
    rotations: Rotations = new Rotations();
    sceneSettings: SceneSettings = new SceneSettings();
    brainModelSettings: BrainModelSettings = new BrainModelSettings();
    sceneClippingSettings: ClippingSettings = new ClippingSettings();
    brainClippingSettings: ClippingSettings = new ClippingSettings('brain');
}

export class Rotations {
    position: THREE.Vector3 = new THREE.Vector3();
    up: THREE.Vector3 = new THREE.Vector3();
}

export class SceneSettings {
    sceneBackgroundColor: string = '#000000';
    directionalLightSelected: boolean = false;
    directionalLightBackgroundColor: string = '#dddddd';
    ambientLightSelected: boolean = true;
    ambientLightBackgroundColor: string = '#dddddd';
}

export class BrainModelSettings {
    hasOutline: boolean = true;
    hasFibers: boolean = false;
    hasCellBodies: boolean = false;
    outlineOpacity: number = 0.2;
    fibersOpacity: number = 0.2;
    cellBodiesOpacity: number = 0.2;
}


export class ClippingSettings {
    top: number;
    bottom: number;
    left: number;
    right: number;
    front: number;
    back: number;
    type: string;

    constructor(type: string = '') {
        this.top = type == "brain" ? 800 : 1000;
        this.bottom = 800;
        this.left = 500;
        this.right = 500;
        this.front = 500;
        this.back = 500;
    }
}